import { useEffect, useState } from "react";
import VideoRecorder from "../src/component/VideoComponent";
// import VideoRecorder from "../src/component/videoComponent/VideoComponent";
// import FaceDetector from "./component/FaceDetector";
import { v4 as uuidv4 } from 'uuid';
import toast, { Toaster } from "react-hot-toast";
import backbutton from './component/asset/back.png'
import api from './component/apiconfig';

const styles = {
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  container: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "10px",
    width: "400px",
    textAlign: "center",
    boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
  },
  title: {
    marginBottom: "10px",
    fontSize: "18px",
    fontWeight: "bold",
  },
  subtitle: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "red",
  },
  instructions: {
    fontSize: "14px",
    marginBottom: "10px",
  },
  list: {
    textAlign: "left",
    paddingLeft: "20px",
    fontSize: "14px",
    marginBottom: "20px",
  },
  retryButton: {
    backgroundColor: "#1E3A8A",
    color: "white",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "bold",
  },
  note: {
    marginTop: "10px",
    fontSize: "12px",
    color: "gray",
  },
};

function App() {
  const [success, setSuccess] = useState(false);
  const [optStatus, setOptstatus] = useState(false);
  const [videoStatus, setVideoStatus] = useState(false);
  const [popMessage, setPopMessage] = useState(false);
  const [popMessageText, setPopMessageText] = useState('');
  const isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent);
  const [params, setParams] = useState({});
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [clientUsage, setClientUsage] = useState(0);
  const [applogo, setApplogo] = useState(null);
  const [authorized, setAuthorized] = useState(false);
  const [count, setCount] = useState(1000);
  const [isLoadingConfig, setIsLoadingConfig] = useState(true);
  const [tokenExpired, setTokenExpired] = useState(false);

  useEffect(() => {
    // setApplogo(applogoconfig);
    // setAuthorized(authorizedconfig);
    loadConfig();
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const loadConfig = async () => {
    try {
      // Import or fetch your config
      const { applogoconfig, authorizedconfig, countconfig } = await import('./component/config'); // or fetch from API
      console.log(applogoconfig, authorizedconfig, countconfig);

      setApplogo(applogoconfig);
      // setAuthorized(authorizedconfig);
      // setCount(countconfig);

    } catch (error) {
      console.error("Error loading config:", error);
    } 
  };

  useEffect(() => {
    if (optStatus) {
      setTimeout(() => {
        setVideoStatus(true)
      }, 2000)
    }
  }, [optStatus]);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const paramsObj = {};
    for (let [key, value] of searchParams.entries()) {
      paramsObj[key] = value;
    }

    if (paramsObj['allowRetry'] === 'true') {
      UserCount()
    }

    setParams(paramsObj);
    checkPermissionsAndShowModal({ setPopMessage, setPopMessageText })
    ValidateToken()
    clientCount()

  }, []);


  async function checkPermissionsAndShowModal({ setPopMessage, setPopMessageText }) {
    const isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent);
    const supportsPermissions = !!(navigator.permissions && navigator.permissions.query);
    const supportsGUM = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);

    const showModal = (text) => {
      setPopMessageText(text);
      setPopMessage(true);
    };

    // Helper: check device availability
    async function checkDevices() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        return { hasVideo: null, hasAudio: null };
      }
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        return {
          hasVideo: devices.some(d => d.kind === 'videoinput'),
          hasAudio: devices.some(d => d.kind === 'audioinput'),
        };
      } catch (err) {
        console.warn('Error enumerating devices:', err);
        return { hasVideo: null, hasAudio: null };
      }
    }

    // 1) Try Permissions API where available
    if (supportsPermissions) {
      const permNames = ['camera', 'microphone'];
      for (const name of permNames) {
        try {
          const res = await navigator.permissions.query({ name });
          if (res.state === 'denied') {
            showModal(
              `${name === 'camera' ? 'Camera' : 'Microphone'} permission is denied. Please enable ${name} in browser/site settings.`
            );
            return false;
          }
        } catch (err) {
          // Some browsers (esp. iOS Safari) throw; fallback behavior below will handle it
          console.warn(`Permission query failed for ${name}:`, err);
        }
      }
    }

    // 2) Check device presence
    const { hasVideo, hasAudio } = await checkDevices();
    if (hasVideo === false) {
      showModal("No camera device detected. Please connect a camera or use a device with a camera.");
      return false;
    }
    if (hasAudio === false) {
      showModal("No microphone detected. Please connect a microphone or use a device with a microphone.");
      return false;
    }

    // 3) Request camera and microphone permissions
    try {
      if (supportsGUM) {
        const tempStream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true
        });
        // Immediately stop tracks to avoid side effects
        tempStream.getTracks().forEach(t => t.stop());
      } else {
        showModal("Camera/microphone not supported by this browser. Use a modern browser (Chrome, Firefox, Safari) or update your device.");
        return false;
      }
    } catch (err) {
      console.error('getUserMedia error:', err);

      // Handle errors uniformly
      if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
        showModal("Camera and/or microphone permission is blocked. Please enable in site settings and refresh the page.");
        return false;
      } else if (err.name === "NotFoundError" || err.name === "DevicesNotFoundError") {
        showModal("No camera/microphone found. Please attach a device or change the selected device in site settings.");
        return false;
      } else if (err.name === "NotReadableError" || err.name === "TrackStartError") {
        showModal("Camera/microphone is already in use by another application. Please close other apps and try again.");
        return false;
      } else {
        showModal("Unable to access camera/microphone. Please check browser settings and try again.");
        return false;
      }
    }

    // 4) Geolocation check (with robust error handling)
    if ("geolocation" in navigator) {
      try {
        const geoRes = await new Promise((resolve) => {
          let isResolved = false;
          let timeoutId = null;

          const handleResolve = (result) => {
            if (!isResolved) {
              isResolved = true;
              if (timeoutId) {
                clearTimeout(timeoutId);
              }
              resolve(result);
            }
          };

          // Set timeout for 15 seconds
          timeoutId = setTimeout(() => {
            handleResolve({
              ok: false,
              msg: "Location request timed out. This may happen if GPS signal is weak."
            });
          }, 15000);

          navigator.geolocation.getCurrentPosition(
            (position) => {
              handleResolve({ ok: true, position });
            },
            (error) => {
              let errorMsg = "Location unavailable.";

              switch (error.code) {
                case error.PERMISSION_DENIED:
                  errorMsg = "Location permission was denied.";
                  break;
                case error.POSITION_UNAVAILABLE:
                  errorMsg = "Location information is unavailable.";
                  break;
                case error.TIMEOUT:
                  errorMsg = "Location request timed out.";
                  break;
                default:
                  errorMsg = "An unknown error occurred while getting location.";
              }
              showModal(
                errorMsg
              );
              handleResolve({ ok: false, err: error, msg: errorMsg });
            },
            {
              timeout: 15000,
              enableHighAccuracy: false, // Faster, uses network location
              maximumAge: 300000 // Accept cached position up to 5 minutes old
            }
          );
        });

        // if (!geoRes.ok) {
        //   showModal(
        //     `Location access failed: ${geoRes.msg} Please enable Location for this site in your browser/site settings.`
        //   );
        //   return false;
        // }
      } catch (err) {
        console.error('Geolocation error:', err);
        showModal("Unable to access location. Please enable Location for this site in your browser/site settings.");
        return false;
      }
    } else {
      // Geolocation not supported - you can choose to return false or true depending on requirements
      console.warn("Geolocation is not supported by this browser.");
      // Uncomment if location is mandatory:
      // showModal("Location is not supported by this browser.");
      // return false;
    }

    // 5) All checks passed
    console.log("All permissions granted successfully!");
    return true;
  }

  async function ValidateToken() {
    setIsLoadingConfig(true);
    const searchParams = new URLSearchParams(window.location.search);
    const paramsObj = {};
    for (let [key, value] of searchParams.entries()) {
      paramsObj[key] = value;
    }
    let token = paramsObj['t']
    const myHeaders = new Headers();
    myHeaders.append("x-api-key", api.x_api_key);
    myHeaders.append("authorizationToken", api.authorizationToken);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "generated_token": token
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };


    fetch(api.validatetoken, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === false) {
          // setTokenExpired(true)
          // setPopMessage(true);
          // setPopMessageText('Invalid Token');
          if (result.data.client_id !== paramsObj.cntid) {
            setAuthorized(false);
          }
          setIsLoadingConfig(false);

        } else {
          setAuthorized(true);
          setIsLoadingConfig(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoadingConfig(false);
      });
  }

  const clientCount = (params) => {
    const searchParams = new URLSearchParams(window.location.search);
    const paramsObj = {};
    for (let [key, value] of searchParams.entries()) {
      paramsObj[key] = value;
    }
    // console.log(params);

    let paramsCntId = paramsObj['cntid'];
    let paramsKycId = paramsObj['kycid'];
    // console.log('paramsCntId, paramsKycId', paramsCntId, paramsKycId);

    // toast.success('Successfully toasted!')
    const myHeaders = new Headers();
    myHeaders.append("x-api-key", api.x_api_key);
    myHeaders.append("authorizationToken", api.authorizationToken);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "clientid": paramsCntId,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(api.getusercount, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log('client count', result, count);
        setClientUsage(result.count);
      })
      .catch((error) => console.error(error));
  };

  const UserCount = (params) => {
    const searchParams = new URLSearchParams(window.location.search);
    const paramsObj = {};
    for (let [key, value] of searchParams.entries()) {
      paramsObj[key] = value;
    }
    // console.log(params);

    let paramsCntId = paramsObj['cntid'];
    let paramsKycId = paramsObj['kycid'];
    // console.log('paramsCntId, paramsKycId', paramsCntId, paramsKycId);

    // toast.success('Successfully toasted!')
    const myHeaders = new Headers();
    myHeaders.append("x-api-key", api.x_api_key);
    myHeaders.append("authorizationToken", api.authorizationToken);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "clientid": paramsCntId,
      "kycid": paramsKycId
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    console.log(paramsCntId, paramsKycId);


    fetch(api.getusercount, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        let data = {
          ...result,
          "result": false,
          "api_status": 0,
          "remark": "user have exhausted all attempts",
          "transcript": "",
          "request_id": "",
          "client_id": paramsCntId,
          "kyc_id": paramsKycId,
          "allowRetry": result.count
        };
        if (result.count >= 3) {
          toast(`Oops! You’ve used all 3 tries.`,
            {
              icon: '❌',
              style: {
                borderRadius: '10px',
                background: '#333',
                color: '#fff',
              },
            }
          );

          window.parent.postMessage(data, "*");
        }

      })
      .catch((error) => console.error(error));
  };

  if (isOnline === false) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', gap: '10px' }}>
      <img src="https://cdn-icons-png.flaticon.com/512/564/564619.png" alt="offline" style={{ width: '100px', height: '100px' }} />
      <h2>You are offline!</h2>
      <p>Please check your internet connection.</p>
    </div>
  }

  // console.log(clientUsage,count);
  if (clientUsage >= count && api.usercount === true) {
    toast(`Usage limit exceeded (${count} max). Current count: ${clientUsage}.`,)
  }

  const handleClosesdk = () => {
    window.parent.postMessage("User has exited the SDK", "*");
    console.log('back');
  }

  if (isLoadingConfig) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <p>Loading...</p>
    </div>
  }


  return (
    <div className="app-container">
      <div><Toaster /></div>
      <div className={`app-content ${!isOnline ? "blurred" : ""}`}>
        {
          popMessage ?
            <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', height: '100vh' }}>
              <div style={styles.modal}>
                <div style={styles.container}>
                  <h2 style={styles.title}>Allow Permissions</h2>
                  <p style={styles.subtitle}>{popMessageText}</p>
                  <p style={styles.instructions}>Steps to continue to use</p>
                  <ol style={styles.list}>
                    <li>Click The Lock Icon On Top-Left Of The Screen.</li>
                    <li>Click "Site Settings"</li>
                    <li>Click "Clear & Reset"</li>
                    <li>Click On "Retry Button"</li>
                  </ol>
                  <button style={styles.retryButton} onClick={() => window.location.reload()}>RETRY</button>
                  <p style={styles.note}>
                    <strong>Note:</strong> If you didn’t deny location permission, kindly copy the link and open in Chrome Browser.
                  </p>
                </div>
              </div>
            </div>
            :
            <>
              {/* {
                success ?
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    gap: '8px',
                    padding: '8px',
                    backgroundColor: '#d4edda',
                    color: '#155724',
                    borderRadius: '5px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    width: '20rem'
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
                    <span style={{ fontSize: '14px', fontWeight: '500' }}>{declarationTextFallback.inPersonVerification}</span>
                  </div>
                  :
                  <>
                    <VideoRecorder setSuccess={setSuccess} />
                  </>
              } */}
              <div style={{ display: 'flex', height: "17px", padding: "2px", cursor: 'pointer' }} onClick={handleClosesdk}>
                <img src={backbutton} style={{ width: '20px', height: "99%", marginTop: '5px' }} alt="App Logo" />
                <p style={{ width: '10px', height: "100%", marginTop: '2px' }}>BACK</p>
              </div>
              <VideoRecorder setSuccess={setSuccess} paramsObj={params} applogo={applogo} authorized={authorized} />
            </>
        }
      </div>
    </div>
  );
}

export default App;